import React, { ReactNode } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { GAME_TYPES_CONFIG, GAME_TYPES_TYPE, operandIcon } from '../../constants/constants';
import { useSignedInContext } from '../../context/SignedInContext';
import getJourneyStages from '../../utils/journeysUtils';
import LinearGradient from 'react-native-linear-gradient';

type TJourneyProgress = {
  gameType: GAME_TYPES_TYPE;
  title?: string;
  additionalIcon?: ReactNode;
  progress: number;
};

export default function JourneyProgress(props: TJourneyProgress) {
  const { gameType, title, additionalIcon, progress } = props;

  // TODO: fetch from backend

  const OperationIcon = operandIcon[GAME_TYPES_CONFIG[gameType].operation];

  return (
    <View style={styles.card}>
      {/* Left side */}
      <View style={styles.leftSection}>
        <View style={styles.iconBox}>
          {additionalIcon ?? <OperationIcon width={46} height={44} />}
        </View>
        <View>
          <Text style={styles.title}>{GAME_TYPES_CONFIG[gameType].operation}</Text>
          <Text style={styles.subtitle}>{title ?? GAME_TYPES_CONFIG[gameType].name}</Text>
        </View>
      </View>

      {/* Right side */}
      <View style={styles.rightSection}>
        <Text style={styles.percent}>{progress}%</Text>
        <LinearGradient
          colors={['rgba(255, 207, 83, 0.55)', 'rgba(255, 153, 0, 0.55)']}
          start={{ x: 0, y: 0 }}
          end={{ x: 1, y: 1 }}
          style={styles.gradientBorder}
        >
          <View style={styles.progressBar}>
            <View style={[styles.progressFill, { flex: progress / 100 }]} />
            <View style={{ flex: 1 - progress / 100 }} />
          </View>
        </LinearGradient>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 12,
    borderRadius: 12,
    width: '100%',
  },
  leftSection: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 0,
  },
  iconBox: {
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    marginRight: 5,
  },

  title: {
    fontFamily: 'Secular One',
    fontWeight: '400',
    fontSize: 14,
    color: '#E87030',
  },
  subtitle: {
    fontFamily: 'Secular One',
    fontWeight: '400',
    fontSize: 12,
    color: '#121212',
  },
  rightSection: {
    alignItems: 'flex-end',
  },
  percent: {
    fontFamily: 'Secular One',
    fontWeight: '400',
    fontSize: 14,
    color: '#121212',
    marginBottom: 4,
  },
  progressBar: {
    flexDirection: 'row',
    height: 16,
    width: 127,
    backgroundColor: '#FFF5DD',
    borderRadius: 8,
    overflow: 'hidden',
    // border: '1px solid #FFB800',
  },
  progressFill: {
    backgroundColor: '#FF9900',
  },
  gradientBorder: {
    borderRadius: 16,
    padding: 2.5,
    height: 22,
  },
});
